<template>
    <div>
        <v-hover v-slot="{ isHovering, props }">
            <v-card
                v-bind="props"
                :elevation="isHovering ? 4 : 0"
                :class="
                    $vuetify.display.mobile
                        ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                        : 'default_card dashboard_card d-flex flex-column ma-0'
                "
                :style="$vuetify.display.mobile ? 'height: 100%' : 'height: 250px'"
            >
                <v-row no-gutters>
                    <v-col
                        cols="12"
                        :class="$vuetify.display.mobile ? 'title ma-2' : 'title ma-0 pa-2 pb-0'"
                    >
                        {{ rowsName }}
                    </v-col>
                    <v-col cols="12" class="px-4 d-flex justify-center">
                        <v-row no-gutters v-if="checkTwoPeriods">
                            <v-col cols="5" class="d-flex flex-column justify-center align-center">
                                <template v-if="loading">
                                    <v-progress-circular
                                        :size="70"
                                        :width="7"
                                        color="primary"
                                        indeterminate
                                        style="margin: 24px"
                                    />
                                </template>
                                <template v-else-if="vuePourcentage" class="pt-3">
                                    <template v-if="dataTotal > 0">
                                        <v-row>
                                            <v-col class="d-flex justify-center">
                                                <v-avatar color="secondary" size="60">
                                                    <v-icon color="white" size="large">
                                                        $trending_up
                                                    </v-icon>
                                                </v-avatar>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters pt-2 align-end>
                                            <v-col class="d-flex font-weight-bold justify-center"
                                                >+ {{ pourcentage }} %</v-col
                                            >
                                        </v-row>
                                    </template>
                                    <template v-else-if="dataTotal < 0">
                                        <v-row>
                                            <v-col class="d-flex justify-center">
                                                <v-avatar color="red" size="60">
                                                    <v-icon color="white" size="large">
                                                        $trending_down
                                                    </v-icon>
                                                </v-avatar>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters pt-2 align-end>
                                            <v-col class="d-flex font-weight-bold justify-center"
                                                >{{ pourcentage }} %</v-col
                                            >
                                        </v-row>
                                    </template>
                                    <template v-else>
                                        <v-row>
                                            <v-col class="d-flex justify-center">
                                                <v-avatar color="grey" size="60">
                                                    <v-icon color="white" size="large">
                                                        $fa-equals
                                                    </v-icon>
                                                </v-avatar>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters pt-2 align-end>
                                            <v-col class="d-flex font-weight-bold justify-center"
                                                >{{ pourcentage }} %</v-col
                                            >
                                        </v-row>
                                    </template>
                                </template>
                                <template v-else>
                                    <bar-chart
                                        v-if="chartData"
                                        :data="chartData"
                                        :options="options"
                                        :width="$vuetify.display.mobile ? 160 : 200"
                                        :height="$vuetify.display.mobile ? 112 : 140"
                                    />
                                </template>
                            </v-col>
                            <v-col cols="1" />
                            <v-col
                                v-if="
                                    chartData &&
                                    chartData.datasets &&
                                    chartData.datasets.length &&
                                    chartData.datasets[0].data &&
                                    chartData.datasets[0].data.length
                                "
                                cols="6"
                                class="px-1 d-flex flex-column justify-center align-center"
                            >
                                <v-row no-gutters align-center>
                                    <v-col cols="6" class="d-flex font-weight-bold align-center">
                                        {{ $vuetify.display.mdAndDown ? "N" : "Année N" }}
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        class="d-flex font-weight-bold justify-end align-center"
                                    >
                                        {{ newCommonFormatCurrency(dataPeriodN, undefined) }}
                                    </v-col>
                                    <v-col cols="6" class="d-flex align-center">
                                        {{ $vuetify.display.mdAndDown ? "N-1" : "Année N-1" }}
                                    </v-col>
                                    <v-col cols="6" class="d-flex justify-end align-center">
                                        {{ newCommonFormatCurrency(dataPeriodNMoinsUn, undefined) }}
                                    </v-col>
                                    <v-col cols="12" class="d-flex justify-end align-center">
                                        <v-divider />
                                    </v-col>
                                    <v-col cols="6" class="d-flex"> Ecart </v-col>
                                    <v-col cols="6" class="d-flex justify-end">
                                        {{ newCommonFormatCurrency(dataTotal, undefined) }}
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="height: 100%" v-else>
                            <v-col class="d-flex flex-column justify-center align-center">
                                <h1>{{ newCommonFormatCurrency(dataPeriodN, undefined) }}</h1>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="mt_auto d-flex align-end">
                        <!-- pb-2 d-flex align-end -->
                        <v-row no-gutters class="pa-2 pt-0" style="min-height: 3rem">
                            <v-col cols="5" class="d-flex justify-center"> </v-col>
                            <v-col cols="2" class="d-flex justify-center" v-if="isHovering">
                                <v-btn-icon
                                    v-show="showBtnDetails"
                                    icon="$fa-search-plus"
                                    class="mx-1"
                                    @click="$emit('onVueDetailedChanged')"
                                    :data-cy="'cardAmount-searchPlus-' + indicator.id"
                                >
                                </v-btn-icon
                                ><!-- indicator.id -->
                                <v-btn-icon
                                    :icon="vuePourcentage ? '$fa-chart-bar' : '$fa-percentage'"
                                    class="mx-1"
                                    @click="vuePourcentage = !vuePourcentage"
                                    v-show="checkTwoPeriods && buttonVuePourcentage"
                                    :data-cy="'cardAmount-percentage-' + indicator.id"
                                >
                                </v-btn-icon>
                            </v-col>
                            <v-col class="d-flex justify-end">
                                <v-btn-trash
                                    class="mx-1"
                                    @click="deleteTheCard()"
                                    v-show="test || isHovering"
                                    :data-cy="'cardAmount-trash-' + indicator.id"
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-hover>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

// import GET_AMOUNT_IN_GENERAL_DICO from "../graphql/dashboardAccounting/GetAmountInGeneralDico.gql";
import GET_INDICATOR_AMOUNT from "../graphql/computedIndicator/GetIndicatorAmount.gql";
// import DELETE_DASHBOARD_SETTING from "../graphql/dashboard/DeleteDashboardSetting.gql";
import DELETE_COMPUTED_INDICATOR from "../graphql/computedIndicator/DeleteComputedIndicatorFromDashboard.gql";

import { Bar as BarChart } from "vue-chartjs";
import { TooltipItem } from "chart.js";
import { chartColors } from "../../../backend/src/common/chart/graphServices";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { ComputedIndicator } from "../../../types/types/indexTypes";

@Component({
    components: {
        BarChart,
    },
    emits: ["deleteTheCard"],
})
export class CardAmount extends Vue {
    @Prop({ default: null }) companyId: string; // obligatoire
    @Prop({ default: null }) periods: any; // obligatoire
    @Prop({ default: null }) indicator: Partial<ComputedIndicator>; // obligatoire
    @Prop({ default: false }) showBtnDetails: boolean;

    loading: boolean = false;

    data: any = null;
    currentPalette = "cool";
    localVuePourcentage: any = "";

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get test(): boolean {
        return this.$store.state.test;
    }

    get twoPeriods() {
        // if (this.settings && this.settings.options && this.settings.options.twoPeriods) {
        //     return this.settings.options.twoPeriods;
        // }
        return true;
    }

    get vuePourcentage() {
        // return this.localVuePourcentage
        if (this.localVuePourcentage !== "") {
            return this.localVuePourcentage;
        }
        // if (
        //     this.settings &&
        //     this.settings.options &&
        //     this.settings?.options?.vuePourcentagep !== undefined
        // ) {
        //     return this.settings.options.vuePourcentage;
        // }
        return false;
    }

    set vuePourcentage(data) {
        this.localVuePourcentage = data;
    }

    get buttonVuePourcentage() {
        // if (this.settings && this.settings.options && this.settings.options.buttonVuePourcentage) {
        //     return this.settings.options.buttonVuePourcentage;
        // }
        return true;
    }

    @Apollo({
        query() {
            return GET_INDICATOR_AMOUNT;
        },
        variables() {
            return {
                indicatorId: this.indicator.id,
                companyId: this.companyId,
                periods: this.periods,
                // key: this.key,
            };
        },
        skip() {
            return !this.periods?.length || !this.indicator;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data.getIndicatorAmount) {
                    this.output = data.getIndicatorAmount.output;
                }
            }
        },
    })
    output: any = {};

    get checkOutput() {
        if (this.output?.tables?.length && this.output.tables[0].rows?.length) {
            return true;
        }
        return false;
    }

    get rows() {
        if (this.checkOutput) {
            return this.output.tables[0].rows[0];
        }
        return null;
    }

    get dataPeriodN() {
        if (this.chartData) {
            return this.rowsValues[0];
        }
        return null;
    }

    get checkTwoPeriods() {
        if (this.twoPeriods) {
            if (this.dataPeriodNMoinsUn) {
                return true;
            }
        }
        return false;
    }

    get dataPeriodNMoinsUn() {
        if (this.twoPeriods && this.chartData) {
            return this.rowsValues[1];
        }
        return null;
    }

    get dataTotal() {
        return this.dataPeriodN - this.dataPeriodNMoinsUn;
    }

    get chartData() {
        if (this.checkOutput) {
            this.data = {
                labels: ["N-1", "N"],
                datasets: [
                    {
                        label: "netAmounts",
                        data: [this.rowsValues[1], this.rowsValues[0]],
                    },
                ],
            };
            if (this.data) {
                let datasets = [];
                datasets = JSON.parse(JSON.stringify(this.data.datasets));

                chartColors("bar", datasets, this.currentPalette);
                const chartData = {
                    labels: this.data.labels,
                    datasets: datasets,
                };
                // console.log("chartdata: ", chartData)
                return chartData;
            }
        }
        return null;
    }

    get rowsName() {
        if (this.rows) {
            return this.rows.name;
        }
        return null;
    }

    get rowsValues() {
        const result = [];
        if (this.checkOutput && this.rows?.netAmounts) {
            for (let item = 0; item < this.rows.netAmounts.length; item++) {
                if (this.rows.displaySign && this.rows.netAmounts[item]) {
                    result[item] = this.rows.displaySign * this.rows.netAmounts[item];
                } else {
                    result[item] = this.rows.netAmounts[item];
                }
            }
            return result;
        }
        return [];
    }

    get pourcentage() {
        return Math.round(
            (100 * (this.dataPeriodN - this.dataPeriodNMoinsUn)) /
                Math.abs(this.dataPeriodNMoinsUn),
        );
    }

    async deleteTheCard() {
        await this.$apollo.mutate({
            mutation: DELETE_COMPUTED_INDICATOR,
            variables: {
                id: this.indicator.id,
                companyId: this.companyId,
            },
        });
        this.$emit("deleteTheCard");
    }

    get options() {
        const self = this;
        return {
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                    position: "bottom",
                },
                tooltip: {
                    mode: "index",
                    position: "average",
                    callbacks: {
                        label: function (tooltipItem: TooltipItem<"bar">): string | string[] {
                            let label = tooltipItem.dataset
                                ? self
                                      .$t("dashboard.amountType." + tooltipItem.dataset.label)
                                      .toString()
                                : "";
                            if (label) {
                                label += " : ";
                            }
                            label += tooltipItem.dataset
                                ? newCommonFormatCurrency(
                                      tooltipItem.dataset.data[tooltipItem.dataIndex],
                                  )
                                : tooltipItem.formattedValue;
                            return label;
                        },
                    },
                },
            },
            scales: {
                y: {
                    stacked: true,
                    // min:0,
                    beginAtZero: true,
                    // stepSize: 1
                },
                x: {
                    stacked: true,
                    // min:0,
                    beginAtZero: true,
                },
            },
            maintainAspectRatio: false,
        };
    }
}

export default toNative(CardAmount);
</script>
